import React from 'react';
import { useIntl } from 'react-intl';
import { Col, Container, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquare } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { nextAsset } from '../../../../components/nextAsset';

export const SmartlinksDescriptionPlaylist: React.FC = () => {
  const intl = useIntl();
  return (
    <div style={{ position: 'relative' }} className="smartlinks-subpages-description">
      <Container>
        <Row className="pt-5">
          <Col xs={12} md={5} className="d-flex align-items-center">
            <div className="d-none d-md-block">
              <img
                src={nextAsset('images/smartLinks/release/preview-description.png')}
                className="img-fluid"
                alt="iphone17"
              />
            </div>
          </Col>
          <Col className="flex-column py-5">
            <h2 className="main-header pt-5 pb-3 text-white text-center text-md-start">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.playlist.description.title',
                defaultMessage: 'Unleash your playlist across all music services'
              })}
            </h2>
            <p className="header-subtitle pb-4">
              {intl.formatMessage({
                id: 'sml.web.smartlinks.playlist.description.subtitle',
                defaultMessage:
                  'Create and distribute your playlists to 120 million listeners across Spotify, Apple Music, YouTube, SoundCloud, Deezer, etc.'
              })}
            </p>
            <Row>
              <Col xs={12}>
                <ul className="fa-ul pt-5">
                  <li className="lead text-white pb-4">
                    <span className="fa-li text-secondary">
                      <FontAwesomeIcon icon={faSquare} />
                    </span>
                    {intl.formatMessage({
                      id: 'sml.web.smartlinks.playlist.description.personalize',
                      defaultMessage: 'Promote your playlists across music services with one single link'
                    })}
                  </li>
                  <li className="lead text-white pb-4">
                    <span className="fa-li text-secondary">
                      <FontAwesomeIcon icon={faSquare} />
                    </span>
                    {intl.formatMessage({
                      id: 'sml.web.smartlinks.playlist.description.customize',
                      defaultMessage: 'Use playlists to grow your streams and increase your followers'
                    })}
                  </li>
                  <li className="lead text-white pb-4">
                    <span className="fa-li text-secondary">
                      <FontAwesomeIcon icon={faSquare} />
                    </span>
                    {intl.formatMessage({
                      id: 'sml.web.smartlinks.playlist.platforms.automatically',
                      defaultMessage: '20 platforms supported'
                    })}
                  </li>
                </ul>
              </Col>
            </Row>

            <div className="bg-subpage-wave">
              <img src={nextAsset('images/smartLinks/wave-subpages.svg')} alt="Background Waves" />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
